import {
  Button,
  Header,
} from '@cloudscape-design/components';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import CollapsedViewToggle from 'components/Trackers/collapsedViewToggle';
import PageContent from 'components/Trackers/pageContent';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';
import useOrderFilter from '../../hooks/use-orderFilter';
import TrackersProvider from './trackersProvider';

export default function ShippedTrackersPage() {
  const navigate = useNavigate();
  const { orderType, FilterButtons } = useOrderFilter();

  const queryParams = useMemo(() => [
    collection(getFirestore(), 'orders'),
    where('hasShippedItems', '==', true),
    ...(orderType ? [where('isInternal', '==', orderType === OrderTypes.INTERNAL)] : []),
    orderBy('orderDate', 'desc'),
  ], [orderType]);

  const { CustomPagination, pageData } = useCustomInfiniteQuery({ queryKey: 'getShippedOrders', queryParams, pageSize: 10 });

  return (
    <div className="trackerPage">
      <Header
        actions={<Button variant="normal" onClick={() => { navigate('/trackers/active'); }}>See active orders</Button>}
        data-element="header"
      >
        <div className="headingAndFilter">
          <div className="heading">Past Orders</div>
          <FilterButtons />
        </div>
      </Header>
      <TrackersProvider orders={pageData} isShipped>
        <div className="optionsBar">
          <CollapsedViewToggle />
          <div className="pagination">
            <CustomPagination />
          </div>
        </div>
        <PageContent />
      </TrackersProvider>
    </div>
  );
}
